<template>
  <div class="wrapper  box_v">
    <!--头部-->
    <page-head title="预约办理" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn">
      <div slot class="box tab-wrapper">
        <div class="tab-btn" @click="$router.replace({name:'appointmentRecord'})">预约记录</div>
        <div class="tab-btn active">服务项目</div>
<!--        <div class="tab-btn" @click="$router.replace({name:'blacklist'})">黑名单</div> -->
      </div>
    </page-head>
    <!--无数据-->
    <Card v-if="isNoData" dis-hover :padding="0" class="nodata-card box_f1">
      <div class=" box_v" style="height: 100%;justify-content: center;align-items: center">
        <img src="../../assets/images/noAppointment.png"/>
        <div class="text">暂无预约办理事项</div>
        <Button class="add-btn" type="primary" @click="handleBtn('add')">新增</Button>
      </div>

    </Card>
    <div v-else class="box_f1 box_v card-box">
      <Card dis-hover :padding="20">
        <i-form ref="formInline" inline label-position="top">
          <row :gutter="80">
            <i-col span="6">
              <FormItem label="事项类型" prop="host">
                <Select v-model="eventTypeId" @on-change="typeChange">
                  <Option
                    v-for="(item,index) in eventTypeList"
                    :value="item.id"
                    :key="index"
                  >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="事项名称" prop="host">
                <Select v-model="eventNameId">
                  <Option
                    v-for="(item,index) in selectType.children"
                    :value="item.id"
                    :key="index"
                  >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="排序" prop="host">
                <Select v-model="sort" @on-change="selectSort">
                  <Option value="0" label="预约数">
                    <span>预约数</span>
                    <span style="float:right;color:#ccc">由多到少</span>
                  </Option>
                  <Option value="1" label="预约数">
                    <span>预约数</span>
                    <span style="float:right;color:#ccc">由少到多</span>
                  </Option>
                  <Option value="2" label="办理数">
                    <span>办理数</span>
                    <span style="float:right;color:#ccc">由多到少</span>
                  </Option>
                  <Option value="3" label="办理数">
                    <span>办理数</span>
                    <span style="float:right;color:#ccc">由少到多</span>
                  </Option>
                </Select>
              </FormItem>
            </i-col>
          </row>
        </i-form>
      </Card>
      <Card dis-hover :padding="0" class="box_f1" style="margin-top: 20px">
        <div class="table-card">
          <div>
            <Button class="bkcc-btn del-btn" @click="delSelectAppiontment">删除</Button>
          </div>
          <Table border :columns="settingColumn" :data="appointmentList" :loading="isTableLoading"
                 @on-select="selectTableItem" @on-select-cancel="cancelTableItem" @on-row-click="clickRow"></Table>
          <page :total="total" @on-change="pageChange" class="page" :page-size="rows" :current="page" show-total/>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
  import pageHead from '../../components/head'

  var that
  export default {
    name: 'appointmentService',
    components: {
      pageHead
    },
    data() {
      return {
        eventTypeList: [],
        page: 1,
        rows: 9,
        orderField: '',// 排序字段 appointmentCount--预约数,processCount--办理数,
        orderSeq: '',//排序类型 DESC、ASC
        eventTypeId: '',// 预约事件类型ID,
        eventNameId: '',//预约事件名称ID,
        status: '',//状态 1--正常预约，2--暂停预约,
        selectType: {},
        appointmentList: [],
        isNoData: false,
        sort: '',
        btnList: [
          {
            name: '搜索',
            type: 'search',
            loading: false,
          }, {
            name: '重置',
            type: 'init',
            loading: false,
            btnType: 'default',
          }, {
            name: '新增',
            type: 'add',
            loading: false,
            btnType: 'default',
          }
        ],
        settingColumn: [
          {
            type: 'selection',
            width: 70,
            align: 'center'
          },
          {
            title: "事项类型",
            key: "type"
          },
          {
            title: "事项名称",
            key: 'name'
          },
          {
            title: "总预约",
            key: "appointmentCount"
          },
          {
            title: "总办理",
            key: "processCount"
          },
          {
            title: "预约时长",
            key: "residentsAppointmentTime"
          },
          {
            title: "状态",
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    {
                      style: {
                        color: that.appointmentList[params.index].status == 1 ? '#ff7b44' : '#a1a1a1',
                      },
                      on: {
                        click: () => {
                          that.changeStatus(params.index)
                        }
                      }
                    },
                    that.appointmentList[params.index].statusName
                  )
                ]);
            }
          },
          {
            title: "操作",
            render: function (h, params) {
              return h("div",
                [
                h(
                  "span",
                  {
                    style: {
                      color: "#5e6d94",
                    },
                    on: {
                      click: (e) => {
                        e.stopPropagation()
                        that.changeStatus(params.index)
                      }
                    }
                  },
                  that.appointmentList[params.index].status == 1 ? "[暂停预约]" : "[开通预约]"
                ),
                h(
                  "span",
                  {
                    style: {
                      color: "#5e6d94",
                      marginLeft: "10px",
                    },
                    on: {
                      click: (e) => {
                        e.stopPropagation()
                        that.editItem(params.index)
                      }
                    }
                  },
                  "[编辑]"
                ),
                h(
                  "span",
                  {
                    style: {
                      color: "#5e6d94",
                      marginLeft: "10px",
                    },
                    on: {
                      click: (e) => {
                        e.stopPropagation()
                        that.delItem(params.index)
                      }
                    }
                  },
                  "[删除]"
                )
              ]);
            }
          },
        ],
        total: 0,
        isTableLoading: false,
        selectAppointment: [],
      }
    },
    methods: {
      // 获取大类等信息
      getEventType() {
        this.$get(this.urlobj.dictionaryList('appointment')).then(res => {
          this.eventTypeList = res.rows.map(item => {
            return {
              id: item.id,
              name: item.dicName,
              children: item.children.map(_item => {
                var remark
                try {
                  remark = JSON.parse(_item.remark).attachment
                } catch (e) {
                  remark = _item.remark
                }
                return {
                  name: _item.dicName,
                  id: _item.id,
                  pic: _item.headPicUrl,
                  remark
                }
              }),
            }
          })
        })
      },
      //选择了大类  回显对应信息
      typeChange(val) {
        //小类清空
        this.eventNameId = ''
        this.eventTypeList.forEach((item, index) => {
          if (item.id == val) {
            this.selectType = item
          }
        })
      },
      initAppointmentList() {
        this.page = 1
        this.getAppointmentList()
      },
      getAppointmentList() {
        let {page, rows, orderField, orderSeq, eventTypeId, eventNameId, status} = this
        this.isTableLoading = true
        this.$post(this.urlobj.getAppointmentList, {
          pageNum: page,
          pageSize: rows,
          orderField,
          orderSeq,
          eventTypeId,
          eventNameId,
          status
        }).then(res => {
          this.isTableLoading = false
          if (!orderField && !orderSeq && !eventTypeId && !eventNameId && !res.total) this.isNoData = true
          this.total = res.total
          this.appointmentList = res.rows.map(item => {
            return {
              id: item.id,
              type: item.eventType,
              name: item.eventName,
              eventNameId: item.eventNameId,
              appointmentCount: item.appointmentCount,
              processCount: item.processCount,
              residentsAppointmentTime:item.residentsAppointmentTime?item.residentsAppointmentTime:"7",
              status: item.status,
              statusName: item.status == 1 ? '可预约' : '不可预约'
            }
          })
        })
      },
      handleBtn(type) {
        if (type == 'add') {
          this.$router.push({name: 'appointmentEdit'})
        } else if (type == 'search') {
          this.initAppointmentList()
        } else if (type == 'init') {
          this.orderField = ''
          this.orderSeq = ''
          this.eventTypeId = ''
          this.eventNameId = ''
          this.sort = ''
          this.initAppointmentList()
        }
      },
      // 选择排序方式
      selectSort(value) {
        if (value == 0) {
          this.orderField = 'appointmentCount'
          this.orderSeq = 'DESC'
        } else if (value == 1) {
          this.orderField = 'appointmentCount'
          this.orderSeq = 'ASC'
        } else if (value == 2) {
          this.orderField = 'processCount'
          this.orderSeq = 'DESC'
        } else if (value == 3) {
          this.orderField = 'processCount'
          this.orderSeq = 'ASC'
        }
      },
      // 改变预约状态
      changeStatus(index) {
        console.log(index)
        console.log(this.appointmentList[index])
        var item = this.appointmentList[index]
        this.$post(this.urlobj.changeAppointmentStatus, {
          idList: item.id,
          status: item.status == 1 ? 2 : 1
        }).then(res => {
          this.$Message.success('操作成功')
          this.getAppointmentList()
        })
      },
      editItem(index) {
        this.$router.push({name: 'appointmentEdit', query: {id: this.appointmentList[index].id}})
      },
      delItem(index) {
        this.delAppiontment(this.appointmentList[index].id)
      },
      delSelectAppiontment() {
        var id = this.selectAppointment.map(item => item.id).join(',')
        if (!id) {
          this.$Message.warning('请选择办理事项')
          return
        }
        this.delAppiontment(id)
      },
      delAppiontment(id) {
        var url = this.urlobj.delAppointment + '?idList=' + id
        this.$delete(url).then(res => {
          this.$Message.success('操作成功')
          this.initAppointmentList()
        })
      },
      pageChange(val) {
        this.page = val;
        this.getAppointmentList();
      },
      selectTableItem(value) {
        this.selectAppointment = this._.unionBy(this.selectAppointment, value, 'id')
      },
      cancelTableItem() {
        var value = arguments[1]
        var delIndex
        this.selectAppointment.forEach((item, index) => {
          if (item.id == value.id) delIndex = index
        })
        this.selectAppointment.splice(delIndex, 1)
      },
      clickRow(value) {
        this.$router.push({
          name: 'appointmentDetail',
          query: {id: value.id, status: value.status, eventNameId: value.eventNameId}
        })
      }
    },
    mounted() {
      that = this
      this.getEventType()
      this.getAppointmentList()
    }
  }
</script>

<style scoped lang="less">
  /deep/ .ivu-form .ivu-form-item-label {
    font-size: 16px;
  }

  /deep/ .ivu-form-inline .ivu-form-item {
    display: block;
  }

  /deep/ .ivu-card-body {
    height: 100%;
  }

  .wrapper {
    height: 100%;
  }

  .add-btn {
    min-width: 60px;
    height: 28px;
    line-height: 13px;
    display: block;
  }

  .del-btn {
    margin-bottom: 20px;
  }

  .tab-wrapper {
    position: absolute;
    left: 20px;
    .tab-btn {
      height: 30px;
      line-height: 30px;
      width: 85px;
      text-align: center;
      background: #fff;
      color: #999;
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
    .active {
      background: #ff7b44;
      color: #fff
    }
  }

  .nodata-card {
    margin: 0 20px 20px;
    align-items: center;
    justify-content: center;
    img {
      height: 280px;
      width: 390px;
    }
    .text {
      font-size: 15px;
      color: #ff7744;
      line-height: 1;
      padding: 25px 0 30px;
      letter-spacing: 10px;
      text-align: center;
    }
  }

  .card-box {
    margin: 0 20px 20px;
  }

  .table-card {
    padding: 20px 20px 80px;
    position: relative;
    height: 100%;
    text-align: right;
  }

  .page {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
</style>
